import { useQuery } from '@tanstack/react-query';
import { Dayjs } from 'dayjs';
import { QueryKey } from '../../enums/QueryKey';
import { getAllSlotDaysInMonthAndYear } from '../../services/slot';
import dayjs from '../../utils/dayjs';

export function useAllSlotDaysInMonthAndYear(date: Dayjs) {
    // Use UTC dates for slot days - we want exact calendar dates without timezone offset
    const dateFromStr = dayjs.utc(date).startOf('month').toISOString();
    const dateToStr = dayjs.utc(date).endOf('month').toISOString();

    const { data, refetch, isFetchedAfterMount, isFetching, isLoading } = useQuery({
        queryKey: [QueryKey.AllSlotDaysInMonthAndYear, { dateFrom: dateFromStr, dateTo: dateToStr }],
        queryFn: () => getAllSlotDaysInMonthAndYear(dateFromStr, dateToStr),
        enabled: !!date,
    });

    return { data, refetch, loading: isFetchedAfterMount ? isLoading : isFetching };
}
